import React from 'react'
import TrashIcon from '../../../elements/icons/TrashIcon'
import ArrowIcon from '../../../elements/icons/ArrowIcon'

const ExaminationCenterCard = ({center, deleteCenter, openCenter}) => {
  return (
    <div className='p-3 bg-white bg-opacity-80 rounded border'>
        <p className='font-medium'>{center.name}</p>
        <p className='text-xs text-gray-500 truncate'>{center.description}</p>
        <p className='text-sm text-gray-900 mt-1'>{center.address}, {center.city} - {center.state}</p>
        <div className="w-full flex items-center justify-between mt-3">
            <button onClick={()=>{openCenter()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Examination Center <ArrowIcon className={`w-5 h-5`} /></button> 

            <button onClick={()=>{deleteCenter()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                <TrashIcon className={`w-5 h-5`} />
            </button>
        </div>

    </div>
  )
}

export default ExaminationCenterCard